import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminEmailQueueHealth = lazy(() => import("@/pages/admin/AdminEmailQueueHealth"));

export const Route = createFileRoute("/admin/email-queue-health")({
  component: AdminEmailQueueHealth,
});
